export default function clampNumber (value: number, minValue: number, maxValue: number): number {
  return value > maxValue ? maxValue : value < minValue ? minValue : value
}
